import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Select,
  Row,
  Col,
  Input,
  message,
  Spin,
} from "antd";
import { baseUrl } from "../utills";
import axios from "axios";
import { CustomInput, CustomPasswordInput } from "./customInput";
import CustomSelector from "./customSelector";
import { green } from "../constants/colors";
import TreeSelector from "./treeSelector";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/msm-motors-black-logo.png";

const SignUpForm = ({ setOpenModal2, setOpenModal3 }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const { Option } = Select;
  const [formLayout, setFormLayout] = useState("vertical");

  const [form2] = Form.useForm();

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 14,
          },
        }
      : null;
  const buttonItemLayout =
    formLayout === "horizontal"
      ? {
          wrapperCol: {
            span: 14,
            offset: 4,
          },
        }
      : null;

  const signUp = async (values) => {
    // console.log("signup values", values);

    try {
      const res = await axios.post(baseUrl + "signup/", values);
      // console.log("signup:", res);
      if (res?.status === 200) {
        setLoading(false);

        messageApi.open({
          type: "success",
          content: "This is a success message",
        });

        navigate("/login");
      }
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  };
  return (
    <div className="w-[95%] sm:w-[80%] md:w-[80%] xl:w-[40%] m-auto py-6 bg-white rounded rounded-[8px] px-8 border border-gray-300">
      {contextHolder}
      <Spin spinning={loading}>
        <Form
          {...formItemLayout}
          layout={formLayout}
          form={form2}
          name="form2"
          onFinish={signUp}
          initialValues={{
            layout: formLayout,
          }}
        >
          <img src={logo} className="m-auto w-[140px] h-[80px] mb-2" alt="" />
          <div className="border-b border-gray-300 mb-6">
            <p className="text-[22px] text-center font-[700] ms-2 mb-4">
              Welcome to <span className="text-customGreen">MSM Motor</span>
            </p>
            {/* <p className="text-[16px] text-center font-[500] mt-0 ms-2 mb-4">
              Enter your email and password to login
            </p> */}
          </div>

          <Row gutter={[23, 0]}>
            <Col xs={24} lg={8} xl={12}>
              <Form.Item
                label={
                  <p
                    style={{
                      color: "gray",
                      marginBottom: "0px",
                    }}
                  >
                    First Name
                  </p>
                }
                name="firstname"
                rules={[
                  { required: true, message: "Please enter your first name" },
                ]}
              >
                <CustomInput placeholder="First Name" />
              </Form.Item>
            </Col>

            <Col xs={24} lg={8} xl={12}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>
                    Last Name
                  </p>
                }
                name="lastname"
                rules={[
                  { required: true, message: "Please enter your last name" },
                ]}
              >
                <CustomInput placeholder="Last Name" />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Email</p>
                }
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please! enter your email address",
                  },
                ]}
              >
                <CustomInput placeholder="Enter your email address" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={8} xl={12}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Password</p>
                }
                name="password"
                rules={[
                  { required: true, message: "Please enter your address" },
                ]}
              >
                <CustomPasswordInput placeholder="Enter your password" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={8} xl={12}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>
                    Confirm Password
                  </p>
                }
                name="confirm_password"
                rules={[
                  { required: true, message: "Please enter your address" },
                ]}
              >
                <CustomPasswordInput placeholder="Enter your password" />
              </Form.Item>
            </Col>
          </Row>
          <p className="text-[16px] text-customGray font-[400] mb-6 ms-2">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/login")}
              className="text-black font-[500] hover:cursor-pointer hover:text-customGreen"
            >
              Login
            </span>
          </p>
          <Form.Item
            //   style={{
            //     display: "flex",
            //   }}
            {...buttonItemLayout}
          >
            <Button
              size="large"
              style={{
                backgroundColor: green,
                borderColor: green,
                color: "black",
                borderRadius: "5px",
                width: "100%",
                //   marginLeft: "10px",
                height: "48px",
                fontWeight: 500,
              }}
              type="primary"
              htmlType="submit"
            >
              Sign Up Now
            </Button>
          </Form.Item>
          <p className="text-[17px] text-customGray text-center font-[400] ms-2">
            By sign up,you agree to the{" "}
            <span
              onClick={() => navigate("/terms-and-policy")}
              className="text-black font-[500] hover:cursor-pointer hover:text-customGreen"
            >
              ‘terms & conditons’
            </span>
          </p>
        </Form>
      </Spin>
    </div>
  );
};

export default SignUpForm;
